import { TEAMS_PAGE } from './pages'

export const selectIsOnTeamsOverviewPage = state =>
  state.ducksPage.page === TEAMS_PAGE
